<template>
  <v-app>
    <Alert :is-active="isAlertActive" />
    <Confirm :is-active="isConfirmActive" />
    <router-view></router-view>
  </v-app>
</template>

<script>
import store from "@/store";
import router from "@/router";
import {mapGetters} from "vuex";
import Alert from "@/common/components/Alert.vue";
import Confirm from "@/common/components/Confirm.vue";

export default {
  name: "App",
  components: {Alert, Confirm},
  computed: {
    ...mapGetters("alert", {
      isAlertActive: "isAlertActive",
      isConfirmActive: "isConfirmActive"
    }),
    memberId() {
      return store.getters["login/memberId"];
    }
  },
  created() {
    if (!this.memberId) {
      router.replace({ name: "Login" });
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/common.scss";
</style>